import { createContext } from 'react'

const SearchLocationContext = createContext([])

export default SearchLocationContext
